import asyncComponent from './asyncComponent';

// eslint-disable-next-line import/no-anonymous-default-export
export default path => asyncComponent(() => import(`./${path}`));
